import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl = `https://backend.alphacapitalgroup.uk/`;
export const fetchChallenges = createAsyncThunk("challenges/fetchChallenges", async () => {
  const response = await axios.get(`${baseUrl}v2/challenges/`);
  return response?.data;
});

const challengesDataSlice = createSlice({
  name: "challengesData",
  initialState: {
    isLoading: false,
    challenges: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchChallenges.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchChallenges.fulfilled, (state, action) => {
        state.isLoading = false;
        state.challenges = action.payload || {};
      })
      .addCase(fetchChallenges.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default challengesDataSlice.reducer;
